import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ChecklistQuestionsVM } from '../../entities/global/model';
import { SafetyConfigService } from '../../services/safety-config.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-config-setup-checklist-edit-question-dialog',
  templateUrl: './config-setup-checklist-edit-question-dialog.component.html',
  styleUrls: ['./config-setup-checklist-edit-question-dialog.component.css']
})
export class ConfigSetupChecklistEditQuestionDialogComponent implements OnInit {

  constructor(public dialogRef:MatDialogRef<ConfigSetupChecklistEditQuestionDialogComponent>,
    private _safetyConfigService:SafetyConfigService,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

    selectedName:any;
    selectedDescription:any;
    questionlist:ChecklistQuestionsVM[]=[]
    inputValueSefetyObservation:number
    placeholder:any

  ngOnInit() {
    this.getquestionlist()
  }
  DialogClose(){
    this.dialogRef.close(false)
  }
  sefetyobservation = new FormControl("", [Validators.required]);
  getErrorMessage() {
    return this.sefetyobservation.hasError("required") ? "You must select a value" : "";
  }
  UpdateQuestion(){
    if(this.inputValueSefetyObservation == undefined || this.selectedName==undefined || this.inputValueSefetyObservation <=0 || this.selectedName==""){
      return;  
      }else{
        let model= new ChecklistQuestionsVM()
        model.QuestionName=this.selectedName;
        model.QuestionsDescription=this.selectedDescription
        model.Active=this.data.active
        model.ID=this.data.catId
        model.QuestionCategoryID=this.data.CategoryID
        model.ObservationTypeId=this.inputValueSefetyObservation
        this._safetyConfigService.updateQuestion(model).subscribe((res: any) =>{
     
      if(res){
        //console.log('result', res)
        this.DialogClose();
       
      }
      
    });
      }
    
}

getquestionlist()

{
 // let model =new ChecklistQuestionsVM();
 this._safetyConfigService.GetAllQuestionsList().subscribe(res => {
   
   this.questionlist=res;
   if(this.questionlist.length>0)
   {
    this.questionlist.map(x=>{
      if( x.ID==this.data.catId){
        this.selectedName = x.QuestionName;
        this.selectedDescription=x.QuestionsDescription;
        this.inputValueSefetyObservation=x.ObservationTypeId;
        console.log("data",this.placeholder)
      }
    })
   }
   
 });
}

}
